import { Action } from '@ngrx/store';
import {
    COMPANY_LOCATIONS_FETCH,
    LOCATIONS_FETCH,
    LOCATION_ADD_START,
    LOCATION_CREATE,
    LOCATION_DELETE,
    LOCATION_DELETE_START,
    LOCATION_ENTITY_SET,
    LOCATION_FETCH,
    LOCATION_SCHEDULES_FETCH,
    LOCATION_UPDATE,
    LOCATION_VIEWED_SET
} from '../action-types';
import { ObservableAction } from '../shared/actions/observable-action';
import { ListItemSetAction, ListItemUnsetAction, ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { SharedAction } from '../shared/actions/shared-action';
import { GROUP_LOCATION } from '../state-groups';
import { LOCATION_ENTITY } from '../entity-types';
import { LocationUpdateRequest } from '@core/models/location/location-update.request';
import { LocationCreateRequest } from '@core/models/location/location-create.request';


export class FetchLocationsAction implements Action {
    readonly type = LOCATIONS_FETCH;
}

@ObservableAction()
export class FetchCompanyLocationsAction implements Action {
    readonly type = COMPANY_LOCATIONS_FETCH;

    constructor(
        public payload: {
            companyId: string;
        }
    ) {}
}

export class SetLocationsFetching
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: boolean) {
        super(payload);
    }
}

export class SetLocationsAction
    extends ListSetAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: any) {
        super(payload);
        payload.domain = LOCATION_ENTITY;
    }
}

export class SetCompanyLocationsAction
    extends ListSetAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: any) {
        super(payload);
        payload.domain = LOCATION_ENTITY;
    }
}

export class SetCompanyLocationAction
    extends ListItemSetAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: any) {
        super(payload);
        payload.domain = LOCATION_ENTITY;
    }
}

export class FetchLocationAction implements Action {
    readonly type = LOCATION_FETCH;

    constructor(
        public payload: {
            locationId: string;
        }
    ) {}
}

@ObservableAction()
export class StartAddLocationAction implements Action {
    readonly type = LOCATION_ADD_START;

    constructor(public payload?: any) {}
}

export class SetViewedLocation implements Action {
    readonly type = LOCATION_VIEWED_SET;

    constructor(public payload: {
        locationId: string
    }) {}
}

export class SetLocationAction
    extends ListItemSetAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: any) {
        super(payload);
        payload.domain = LOCATION_ENTITY;
    }
}

export class SetLocationEntityAction implements Action {
    readonly type = LOCATION_ENTITY_SET;

    constructor(
        public payload: {
            location: Location;
        }
    ) {}
}

@ObservableAction()
export class UpdateLocationAction implements Action {
    readonly type = LOCATION_UPDATE;

    constructor(
        public payload: {
            locationId: string;
            request: LocationUpdateRequest;
        }
    ) {}
}

@ObservableAction()
export class CreateLocationAction implements Action {
    readonly type = LOCATION_CREATE;

    constructor(
        public payload: {
            request: LocationCreateRequest;
        }
    ) {}
}

@ObservableAction()
export class DeleteLocationAction implements Action {
    readonly type = LOCATION_DELETE;

    constructor(
        public payload: {
            locationId: string;
        }
    ) {}
}

@ObservableAction()
export class StartDeleteLocationAction implements Action {
    readonly type = LOCATION_DELETE_START;

    constructor(
        public payload: {
            location: Location;
        }
    ) {}
}

export class RemoveLocationAction
    extends ListItemUnsetAction
    implements SharedAction {
    name = GROUP_LOCATION;

    constructor(payload: any) {
        super(payload);
        payload.domain = LOCATION_ENTITY;
    }
}

export class FetchLocationSchedulesAction implements Action {
    readonly type = LOCATION_SCHEDULES_FETCH;

    constructor(
        public payload: {
            locationId: string;
        }
    ) {}
}

export class SetViewedLocationAction implements Action {
    readonly type = LOCATION_VIEWED_SET;

    constructor(
        public payload: {
            locationId: string;
        }
    ) {}
}
